import { get, } from '.';

export function GetConferenceFollowUps(conferenceVid, options = {}) {
	return get<any>("/app/api/conferences/" + conferenceVid + "/follow_ups", options);
}